import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

export const MarketingHeader = () => {
  const location = useLocation();
  const { user } = useAuth();

  const navLink = (to, label) => {
    const active = location.pathname === to;
    return (
      <Link
        to={to}
        className={`text-sm transition-colors ${
          active ? 'text-amber-200' : 'text-slate-400 hover:text-white'
        }`}
        data-testid={`marketing-nav-${label.toLowerCase()}`}
      >
        {label}
      </Link>
    );
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="marketing-logo">
          <img
            src="/logo.png"
            alt="PROP VEIW"
            className="w-14 h-14 object-contain rounded-lg bg-white/95 p-1.5 ring-1 ring-amber-300/40 group-hover:ring-amber-300/70 shadow-lg shadow-amber-500/10 transition-all"
          />
          <span className="font-manrope font-bold text-xl text-white tracking-tight">PROP VEIW</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLink('/', 'Product')}
          {navLink('/features', 'Features')}
          {navLink('/pricing', 'Pricing')}
          <a
            href="mailto:hello@propveiw.com"
            className="text-sm text-slate-400 hover:text-white transition-colors"
          >
            Contact
          </a>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <Link to="/dashboard">
              <Button size="sm" className="bg-amber-400 hover:bg-amber-300 text-[#070d1c] font-semibold shadow-md shadow-amber-500/20" data-testid="marketing-open-app">
                Open app
              </Button>
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                className="text-sm text-slate-300 hover:text-white transition-colors hidden sm:block"
                data-testid="marketing-signin-link"
              >
                Sign in
              </Link>
              <Link to="/register">
                <Button size="sm" className="bg-amber-400 hover:bg-amber-300 text-[#070d1c] font-semibold shadow-md shadow-amber-500/20" data-testid="marketing-cta-header">
                  Start free trial
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default MarketingHeader;
